export default "__VITE_ASSET__DGSU5YsS__"